mutation ExportQuotas {
    quotasExport {
        url
    }
}
